<template>
  <zul-modal
    id="three-ds-auth-modal"
    class="is-small three-ds-auth-modal"
    ref="modal"
    title="Autenticar cartão"
  >
    <p v-if="isLoading" class="loading">{{ $t("global.loading") }}</p>
    <div id="challenge-container-ref" ref="challengeContainerRef" />
  </zul-modal>
</template>

<script>
/* eslint-disable */

import Vue from "vue";
import { ThreeDsAuth, Events } from "@zuldigital/classic-adyen-3ds";

import { getIdentifierHeaders } from "@zuldigital/utils";
import config from "config";
import axios from "axios";

axios.interceptors.request.use((instance) => {
  instance.headers = {
    Authorization: "Bearer " + Vue.prototype.$auth.token(),
    "X-City": Vue.prototype.app.city,
    "X-Origin": "WEB_APP",
    ...getIdentifierHeaders(),
  };
  return instance;
});

export default {
  data() {
    return {
      isLoading: false,
      threeDsAuth: undefined,
      hasAuthenticationFinished: false,
    };
  },
  mounted() {
    this.$root.$on("open-three-ds-auth-modal", () => {
      this.$refs.modal.open();
    });

    this.$root.$on("close-three-ds-auth-modal", () => {
      this.$refs.modal.close();

      if (!this.hasAuthenticationFinished) {
        this.$buefy.toast.open({
          message: "Autenticação não foi finalizada",
          type: "is-danger",
        });

        this.threeDsAuth.cancelPaymentAuthentication().catch(() => {});
      }
    });
  },
  destroyed() {
    this.$root.$off("open-three-ds-auth-modal");
    this.$root.$off("close-three-ds-auth-modal");
  },
  methods: {
    open({ id, status }) {
      this.isLoading = true;
      this.$refs.modal.open();

      const FINGERPRINT_POST_BACK_URL = `${config.API_URL.replace(
        "/v7",
        ""
      )}/external/payment/3ds/fingerprint`;

      const URL = config.API_URL;

      return new Promise((resolve, reject) => {
        this.threeDsAuth = new ThreeDsAuth(
          {
            orderId: id,
            category: "CAD",
            status,
            getChallengeIframeContainer: () => {
              return new Promise((resolve) => {
                setTimeout(() => {
                  resolve(this.$refs.challengeContainerRef);
                }, 0);
              });
            },
            FINGERPRINT_POST_BACK_URL,
            URL,
          },
          this.$http
        );

        this.threeDsAuth
          .on(Events.CLOSE_MODAL, () => {
            this.$refs.modal.close();
          })
          .on(Events.START_LOADING, () => {
            this.isLoading = true;
          })
          .on(Events.FINISH_LOADING, () => {
            this.isLoading = false;
          })
          .on(Events.EMPTY_AUTH, () => {})
          .start()
          .then((response) => {
            this.hasAuthenticationFinished = true;
            resolve(response);
          })
          .catch(reject);
      });
    },
    close() {
      this.$refs.modal.close();
    },
    startLoading() {
      this.isLoading = true;
    },
    finishLoading() {
      this.isLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/sass/variables";

.loading {
  background: url("../assets/loading.svg") no-repeat center center;
  background-size: 100px;
  text-align: center;
  padding: 7rem 0 0;
  font-size: $size-7;
  // opacity: 0.5;
  opacity: 1;
  margin-right: 0;

  background-color: #313131;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 2;
}
</style>
<style>
.three-ds-auth-modal .modal-card-foot {
  display: none !important;
}

.three-ds-auth-modal .modal-card-body {
  padding: 0 !important;
  background-color: #fff !important;
}

#challenge-container-ref {
  min-height: 420px;
  box-sizing: border-box;
}

#challenge-container-ref iframe {
  height: 420px;
  padding: 10px 10px 0;
  box-sizing: border-box;
}

.three-ds-auth-modal .modal-card-body > div:first-child {
  max-width: 450px;
  margin: 0 auto;
}
</style>
